import { useEffect, useState } from "react"
import { getStepsStatsLasTwoMonthsPerHour, changeDateLastTwoMonthHourInDayChart } from "redux/reducers/stepsReducer"
import BarChartDateCalendarSelector from "components/Charts/BarChartDateCalendarSelector"
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerHourTotalInDay = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())

  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ stepsData }) => stepsData.lastTwoMonthsPerHourInDayPatientData)
  const chartData = useSelector(({ stepsData }) => stepsData.perHourChartTotalStepsInDay)

  const dispatch = useDispatch()

  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getStepsStatsLasTwoMonthsPerHour(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateLastTwoMonthHourInDayChart(selectedDate.toISOString()))
    }
  }, [data, dispatch, patientId, selectedDate, status])


  return (
    <BarChartDateCalendarSelector
      dataToShow={chartData}
      title={Dashboard.STEPS_HOUR}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={null}
      maxDate={new Date()}
    />
  )
}

export default PerHourTotalInDay